import React from 'react';
export function FolderAddIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M11 9h2v3h3v2h-3v3h-2v-3H8v-2h3V9z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5v16H2V3h7l2 2h11zM10.172 7l-2-2H4v14h16V7h-9.828z"
  }));
}